var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1798_40801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 9,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9619 1.66797H19.0777V8.77865H11.9619V1.66797Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1798_40801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4525 8.77865C18.1383 8.77865 17.8683 8.54281 17.8325 8.22365C17.5167 5.41031 15.3317 3.22698 12.5175 2.91448C12.175 2.87615 11.9275 2.56781 11.9658 2.22448C12.0033 1.88198 12.3092 1.62948 12.6558 1.67281C16.0542 2.05031 18.6933 4.68615 19.0742 8.08365C19.1125 8.42698 18.8658 8.73615 18.5233 8.77448C18.5 8.77698 18.4758 8.77865 18.4525 8.77865Z",
    fill: "url(#paint0_linear_1798_40801)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5022 8.78793C15.2089 8.78793 14.948 8.58127 14.8897 8.28293C14.6497 7.0496 13.6989 6.09877 12.4672 5.8596C12.128 5.79377 11.9072 5.46627 11.973 5.1271C12.0389 4.78793 12.3722 4.56627 12.7055 4.63293C14.4397 4.9696 15.7789 6.30793 16.1164 8.04293C16.1822 8.38293 15.9614 8.71043 15.623 8.77627C15.5822 8.78377 15.5422 8.78793 15.5022 8.78793Z",
    fill: "url(#paint1_linear_1798_40801)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1798_40801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 1.66797H18.7505V18.7517H1.66699V1.66797Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1798_40801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6329 4.21925C3.63456 4.21925 3.5929 4.26259 3.5404 4.31425C3.33873 4.51009 2.92123 4.91759 2.91706 5.77009C2.9104 6.96259 3.69456 9.17675 7.4704 12.9518C11.2279 16.7084 13.4387 17.5018 14.6346 17.5018H14.6521C15.5046 17.4968 15.9112 17.0793 16.1071 16.8784C16.1662 16.8176 16.2146 16.7718 16.2487 16.7443C17.0796 15.9084 17.5046 15.2876 17.5004 14.8884C17.4954 14.4818 16.9896 14.0018 16.2904 13.3359C16.0679 13.1251 15.8262 12.8943 15.5712 12.6393C14.9096 11.9801 14.5837 12.0926 13.8629 12.3459C12.8671 12.6951 11.5029 13.1734 9.37706 11.0459C7.2504 8.92009 7.72706 7.55592 8.07456 6.55925C8.32623 5.83925 8.44123 5.51175 7.7804 4.85009C7.52206 4.59175 7.28956 4.34675 7.0754 4.12175C6.41373 3.42675 5.93623 2.92425 5.53206 2.91842H5.5254C5.12623 2.91842 4.50623 3.34509 3.62873 4.22259C3.63123 4.22009 3.63206 4.21925 3.6329 4.21925ZM14.6346 18.7518C12.5579 18.7518 9.8504 17.0984 6.58706 13.8359C3.3104 10.5601 1.65456 7.84425 1.66706 5.76342C1.67456 4.38842 2.3954 3.68425 2.66623 3.42009C2.6804 3.40259 2.72873 3.35509 2.7454 3.33842C3.94123 2.14259 4.7629 1.65092 5.5479 1.66842C6.47873 1.68092 7.14206 2.37842 7.98123 3.26092C8.18873 3.47842 8.4129 3.71592 8.66373 3.96592C9.87956 5.18259 9.53373 6.17509 9.25456 6.97175C8.95123 7.84092 8.68873 8.59092 10.2604 10.1626C11.8321 11.7343 12.5812 11.4718 13.4496 11.1659C14.2471 10.8876 15.2371 10.5393 16.4554 11.7559C16.7029 12.0034 16.9362 12.2251 17.1529 12.4309C18.0387 13.2743 18.7387 13.9401 18.7504 14.8734C18.7596 15.6684 18.2762 16.4801 17.0829 17.6734L16.5546 17.3151L17.0021 17.7509C16.7379 18.0218 16.0354 18.7434 14.6596 18.7518H14.6346Z",
    fill: "url(#paint2_linear_1798_40801)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40801",
    x1: 15.52,
    y1: 1.66797,
    x2: 15.52,
    y2: 8.77865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30FF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40801",
    x1: 14.0447,
    y1: 4.62109,
    x2: 14.0447,
    y2: 8.78793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30FF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40801",
    x1: 10.2088,
    y1: 1.66797,
    x2: 10.2088,
    y2: 18.7518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30FF41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D9927"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallsIcon);
export default __webpack_public_path__ + "static/media/calls-icon.51adc83f23d43a512fc2a86fd36b5fb6.svg";
export { ForwardRef as ReactComponent };